<template>

    <div class="datepicker" :class="'size-' + size">
        <datepicker
            :disabled="disabled"
            :format="format"
            :typeable="false"
            :value="val"
            calendar-class="datepicker-calendar"
            input-class="datepicker-input"
            maximum-view="day"
            placeholder="Select Date"
            @selected="onSelected">
        </datepicker>
        <div class="arrow">
            <i class="fas fa-chevron-down ml-5"></i>
        </div>
    </div>

</template>

<style lang="scss">

    .datepicker {
        position: relative;
        &.size-sm {
            .datepicker-input {
                height: 40px;
                padding: 0 12px;
            }
            .datepicker-calendar {
                margin-bottom: 45px;
            }
            .arrow {
                height: 40px;
                width: 40px;
            }
        }
        &.size-md {
            .datepicker-input {
                height: 50px;
                padding: 0 15px;
            }
            .datepicker-calendar {
                margin-bottom: 55px;
            }
            .arrow {
                height: 50px;
                width: 50px;
            }
        }
        .arrow {
            display: grid;
            font-size: 11px;
            height: 50px;
            position: absolute;
            pointer-events: none;
            place-items: center;
            right: 0;
            top: 0;
        }
    }

    .datepicker-input {
        @include font-medium(13px);
        appearance: none;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        box-sizing: border-box;
        color: $color-text;
        cursor: pointer;
        outline: none;
        transition: border-color .3s;
        width: 100%;
        &:hover, &:focus {
            border-color: $color-text;
            color: $color-text;
        }
        &:disabled {
            background: $color-bg;
            border-color: $color-rule;
            color: $color-text;
            opacity: 1;
        }
    }

    .datepicker-calendar {
        @include font-medium(13px);
        @include shad(2);
        border: 1px solid $color-rule;
        border-radius: 3px;
        margin-top: 5px;
        max-width: 250px;
        padding: 10px;
        header span,
        .cell.day,
        .cell.day-header {
            border: none;
            color: $color-text;
            height: 30px;
            line-height: 30px;
            margin: 0;
            padding: 0;
        }
        header {
            span.prev, span.next {
                background: none !important;
                transition: opacity .3s;
                &:hover {
                    opacity: 0.5;
                }
            }
            .day__month_btn {
                cursor: default;
            }
        }
        .cell.day-header {
            cursor: default !important;
        }
        .cell.day {
            border-radius: 3px;
            transition: background-color .3s;
            &:hover {
                border: none !important;
                color: $color-primary;
            }
            &.today {
                background-color: $color-bg;
            }
            &.selected {
                background-color: $color-primary;
                color: #fff;
                &:hover {
                    background-color: $color-primary-hover;
                }
            }
        }
    }

</style>

<script>

import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {

    components: {
        'datepicker': Datepicker,
    },

    props: {
        model: {
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        },
        timezone: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        // Field display format.
        format: {
            type: String,
            default: 'M/dd/yy',
        },
        // Input and output date format.
        unix: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            val: this.getValue(),
        }
    },

    watch: {

        timezone(val) {
            let date = moment(this.val).tz(val).startOf('day').utc();
            if (this.unix) {
                date = date.unix();
            } else {
                date = date.format('YYYY-MM-DD');
            }
            this.$emit('input', date);
        },

    },

    methods: {

        onSelected(val) {
            let date = moment(val).startOf('day').utc();
            if (this.timezone) {
                date = moment(val).tz(this.timezone).startOf('day').utc();
            }
            if (this.unix) {
                date = date.unix();
            } else {
                date = date.format('YYYY-MM-DD');
            }
            this.$emit('input', date);
        },

        getValue() {
            if (this.model && this.unix) {
                return moment.unix(this.model).toISOString();
            } else if (this.model) {
                return moment(this.model).toISOString();
            }
        },

    },

}

</script>
